export enum BulkOperationJobType {
  WorkflowBulkAssignment = 'WORKFLOW_BULK_ASSIGNMENT',
}
